/* eslint-disable valtio/state-snapshot-rule */
import { useJumpChat } from '@/hooks/useJumpChat'
import { assistantState, configState } from '@/store'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useSnapshot } from 'valtio'
import kn_post from '@/assets/images/chat/kn_post.png'

interface FeatureItem {
  id?: string | null
  url?: string | null
  name?: string | null
  type?: number | null
  description?: string | null
  image?: string | null
  knowledge_id?: string | null
  app_id?: string | null
  is_hot?: boolean | null
  prompt?: string | null
  is_like?: boolean | null
  agent_type?: string | null
}
export default function HotHelper() {
  const { featuredApps } = useSnapshot(assistantState)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [direction, setDirection] = useState<'left' | 'right'>('right')
  const [isAnimating, setIsAnimating] = useState(false)
  const navigator = useNavigate()
  const { jumpToChat } = useJumpChat()

  // 移除自动轮播，改为手动点击切换
  // useEffect(() => {
  //   if (featuredApps?.length > 0) {
  //     const timer = setInterval(() => {
  //       if (!isAnimating) {
  //         setDirection('right')
  //         setCurrentIndex((prev) => (prev + 1) % featuredApps.length)
  //       }
  //     }, 3000)
  //     return () => {
  //       clearInterval(timer)
  //     }
  //   }
  // }, [featuredApps, isAnimating])

  useEffect(() => {
    setIsAnimating(true)
    const timer = setTimeout(() => {
      setIsAnimating(false)
    }, 500)
    return () => {
      clearTimeout(timer)
    }
  }, [currentIndex])

  const clickCard = () => {
    jumpToChat(featuredApps[currentIndex])
  }

  const handleDotClick = (index: number) => {
    if (index === currentIndex || isAnimating) return
    setDirection(index > currentIndex ? 'right' : 'left')
    setCurrentIndex(index)
  }

  if (!featuredApps?.length) return null

  return (
    <Warper>
      <CarouselContainer direction={direction} currentIndex={currentIndex}>
        {featuredApps.map((item: FeatureItem, index: number) => (
          <CarouselItem
            key={index}
            style={{
              backgroundImage: `url(${item.agent_type === 'kn' ? kn_post : item.image})`,
              backgroundSize: 'cover',
            }}
            onClick={() => {
              if (item.agent_type === 'kn') {
                navigator('/knowledge')
                return
              }
              clickCard()
            }}
          >
            {/* <div className="assistant">最热助手</div> */}
            {item.agent_type !== 'kn' && (
              <div className="hint">
                <div className="title">{item.name}</div>
                <div className="prompt">{item.description}</div>
              </div>
            )}
          </CarouselItem>
        ))}
      </CarouselContainer>
      <div className="dots">
        {featuredApps.map((_: FeatureItem, index: number) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={e => {
              e.stopPropagation()
              handleDotClick(index)
            }}
          />
        ))}
      </div>
    </Warper>
  )
}

const Warper = styled.div`
  position: relative;
  width: 240px;
  height: 292px;
  border-radius: 12px;
  overflow: hidden;

  .dots {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 1;

    .dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.5);
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        background: #fff;
        transform: scale(1.2);
      }
    }
  }
`

const CarouselContainer = styled.div<{
  direction: 'left' | 'right'
  currentIndex: number
}>`
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
  transform: translateX(${props => `-${props.currentIndex * 100}%`});
`

const CarouselItem = styled.div`
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 12px;
  background-size: cover;
  background-position: center;
  position: relative;

  .assistant {
    position: absolute;
    top: 0;
    left: 0;
    width: 84px;
    height: 26px;
    color: #fff;
    line-height: 28px;
    text-align: left;
    text-indent: 10px;
    font-size: 14px;
    font-weight: 500;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    opacity: 0px;
    border-top-left-radius: 12px;
    border-bottom-right-radius: 12px;
    background: linear-gradient(104.04deg, #fdb6b6 0%, #bf0040 100%);
  }

  .hint {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    padding: 2px 12px 12px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.8) 100%
    );
    border-radius: 0px 0px 8px 8px;
    opacity: 0px;

    .title {
      color: #fff;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.01em;
      text-align: left;
    }
    .prompt {
      display: -webkit-box;
      width: 100%;
      height: 38px;
      overflow: hidden;
      color: #fff;
      font-weight: 400;
      font-size: 12px;
      white-space: pre-wrap;
      text-align: left;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
`
